<template>
  <el-dialog
      :title="type === 'edit' ? '发票抬头管理' : '开发票'"
      append-to-body
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">

    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        v-loading="loading"
    >

      <el-row>
        <el-col :span="24">
          <el-form-item prop="headerTitle" label="发票抬头名称">
            <el-input
                :disabled="type === 'add'"
                v-model="ruleForm.headerTitle"
                placeholder="请输入发票抬头名称"
            />
          </el-form-item>
          <el-form-item prop="taxpayerNumber" label="信用代码">
            <el-input
                :disabled="type === 'add'"
                v-model="ruleForm.taxpayerNumber"
                placeholder="请输入信用代码"
            />
          </el-form-item>
          <el-form-item prop="email" label="邮箱">
            <el-input
                :disabled="type === 'add'"
                v-model="ruleForm.email"
                placeholder="请输入邮箱"
            />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" v-if="type === 'edit'">保 存</el-button>
      <el-button type="primary" @click="handleSubmit" v-if="type === 'add'">预 览</el-button>
    </span>

  </el-dialog>
</template>

<script>

export default {
  name: "invoiceHeader",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'edit'
    },
    product: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    var validCode = (rule, value, callback) => {
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (value === "") {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };

    const validateEmail = (rule, value, callback) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value === "") {
        callback(new Error("请输入电子邮箱"));
      } else if (!emailRegex.test(value)) {
        callback(new Error("请输入正确的电子邮箱"));
      } else {
        callback();
      }
    }

    return {
      loading: false,
      ruleForm: {},
      rules: {
        taxpayerNumber: [{required: true, validator: validCode, trigger: ["blur","change"]}],
        email: [{required: true, validator: validateEmail, trigger: ["blur","change"]}],
      },
      queryParams: {
        pageNum: 1,
        pageSize: 1,
      },
    };
  },
  created() {
    this.getInvoiceHeader()
  },
  methods:{
    getInvoiceHeader(){
      this.loading = true
      this.$http.get(this.$api.invoice.getInvoiceHeader ,this.queryParams).then(res => {
        if (res.data.code == 200) {
          if(res.data.total >= 1){
            this.ruleForm = res.data.rows[0]
          }
          this.loading = false
        }else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    handleSubmit(){
      if (this.type === 'edit'){
        this.loading = true
        if (this.ruleForm.headerId){
          this.$http.post(this.$api.invoice.updateInvoiceHeader , this.ruleForm).then(res => {
            if (res.data.code == 200) {
              this.$message.success('修改成功')
              this.updateDialog(false)
              this.loading = false
            }else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }else {
          this.$http.post(this.$api.invoice.insertInvoiceHeader , this.ruleForm).then(res => {
            if (res.data.code == 200) {
              this.$message.success('保存成功')
              this.updateDialog(false)
              this.loading = false
            }else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }
      }else if (this.type === 'add'){
        this.$emit('handleInvoicing' , {type: true, list: this.ruleForm})
      }
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
